/* ============================================================
   Pages inscription (pro + particulier) : panneau de continuation
   post-inscription + redirection dirigee vers la connexion
   ------------------------------------------------------------
   Contexte : la boutique utilise les NOUVEAUX comptes clients Shopify
   (passwordless). La creation de compte via Shopify Forms NE connecte
   PAS le navigateur : seule la saisie du code recu par e-mail ouvre une
   session (limite plateforme, pas de connexion programmatique possible).

   A la reussite de l'inscription, on masque le message generique du bloc
   Shopify Forms et on affiche un panneau clair "Compte cree" avec un
   bouton explicite vers la connexion, sans redirection automatique ni
   phrase d'explication (le code n'est envoye qu'une fois sur la page de
   connexion : annoncer un « code recu » trompait le client, 29/09/2026).
   Vaut pour le PRO comme pour le PARTICULIER (le pro etait auparavant bloque sur "Demande envoyee",
   sans aucune redirection).

   Destination (return_to) CONTEXTUELLE :
   - parcours SAV (parametre ?from=sav OU drapeau localStorage
     fog_sav_return frais < 1h) -> retour direct sur /pages/sav, meme si
     le compte pro n'est pas encore valide (le SAV est ouvert a tout
     compte connecte) ;
   - sinon -> espace correspondant a la page (/pages/espace-pro pour
     l'inscription pro, /pages/espace-particulier pour l'inscription
     particulier).
   L'e-mail saisi est passe en login_hint (pre-rempli a la connexion).

   IMPORTANT (cause du non-fonctionnement initial cote pro) :
   Shopify Forms rend TOUT le formulaire dans un Web Component a Shadow DOM
   (<shopify-forms-embed>). Il n'existe AUCUNE balise <form> dans le light
   DOM : form, inputs (#email), bouton et message de succes vivent dans le
   shadow root (ouvert). On opere donc DANS ce shadow root.

   Detection du succes (verifiee sur le markup reel du bloc Forms) :
   - l'attribut data-current-step de [data-form-root] quitte la valeur
     "form" (etape de confirmation), OU le <form> disparait du shadow root.
     Une erreur de validation laisse step="form" -> aucun faux positif.
   ============================================================ */
(function () {
  "use strict";

  /* Libelles : snippets/i18n-js.liquid (window.FOG_I18N, charge avant ce script
     par layout/theme.liquid). Lu a l'appel, jamais en dur. Spec 07. */
  function i18n(cle, vars) {
    return window.FOG_I18N.t(cle, vars);
  }

  var LOGIN_URL = "/customer_authentication/login";
  var SAV_PAGE = window.FOG_ROUTES.pages["sav"];
  var SAV_FLAG_KEY = "fog_sav_return";
  var SAV_FLAG_TTL = 3600000; // 1h : identique a section-sav-form.js / theme.liquid
  var POLL_INTERVAL = 200; // ms : attente de l'hydratation du web component
  var POLL_TIMEOUT = 20000; // ms : filet, on cesse d'attendre ensuite

  function hasFreshSavFlag() {
    try {
      var ts = parseInt(localStorage.getItem(SAV_FLAG_KEY) || "0", 10);
      return ts ? Date.now() - ts <= SAV_FLAG_TTL : false;
    } catch (e) {
      return false;
    }
  }

  function fromSavQuery() {
    try {
      return new URLSearchParams(location.search).get("from") === "sav";
    } catch (e) {
      return false;
    }
  }

  function boot() {
    var container = document.querySelector(".b2b-register__app-form");
    if (!container) return; // form non relie (placeholder) ou client deja connecte : rien a faire

    var card =
      container.closest(".b2b-register__form-card") || container.parentNode;

    // Contexte SAV fige au chargement (le drapeau peut expirer pendant la saisie).
    var isSav = fromSavQuery() || hasFreshSavFlag();
    var isParticulier =
      location.pathname.indexOf(window.FOG_ROUTES.pages["inscription-particulier"]) !== -1;
    var destination = isSav
      ? SAV_PAGE
      : isParticulier
      ? window.FOG_ROUTES.pages["espace-particulier"]
      : window.FOG_ROUTES.pages["espace-pro"];

    var capturedEmail = "";
    var redirecting = false;

    function buildRedirectUrl() {
      var url = LOGIN_URL + "?return_to=" + encodeURIComponent(destination);
      if (capturedEmail) {
        url += "&login_hint=" + encodeURIComponent(capturedEmail);
      }
      return url;
    }

    function showPanelAndRedirect() {
      if (redirecting) return;
      redirecting = true;

      // Contexte SAV : on rafraichit le drapeau pour que le filet de
      // theme.liquid reste frais apres l'OTP, meme si la saisie a dure.
      if (isSav) {
        try {
          localStorage.setItem(SAV_FLAG_KEY, String(Date.now()));
        } catch (e) {}
      }

      var url = buildRedirectUrl();
      var ctaLabel = isSav
        ? i18n("account.register.continue_request")
        : i18n("account.register.continue_space");

      // Masque le contenu existant de la carte (titre / intro / message Forms)
      // avant d'inserer le panneau : un seul message clair a l'ecran.
      // `hidden` seul ne suffit pas : `.b2b-register__app-form { display: block }`
      // l'emporte sur la regle du navigateur, et le « Demande envoyee » de Shopify
      // Forms restait affiche au-dessus du panneau (vu le 29/09/2026).
      Array.prototype.forEach.call(card.children, function (child) {
        child.hidden = true;
        child.style.setProperty("display", "none", "important");
      });

      var panel = document.createElement("div");
      panel.className = "register-success";

      // Titre seul, sans phrase d'explication : « connectez-vous avec le code recu
      // par e-mail » laissait croire qu'un code etait deja arrive, alors qu'il n'est
      // envoye qu'une fois sur la page de connexion (decision Joris, 29/09/2026).
      panel.innerHTML =
        '<div class="register-success__icon" aria-hidden="true">' +
        '<svg width="34" height="34" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        "</div>" +
        '<div role="status">' +
        '<h2 class="register-success__title"></h2>' +
        "</div>";
      // Libelle en textContent : la chaine traduite n'entre jamais dans innerHTML.
      panel.querySelector(".register-success__title").textContent = i18n("account.register.success_title");

      var cta = document.createElement("a");
      cta.className = "register-success__cta btn-primary";
      cta.setAttribute("href", url);
      cta.textContent = ctaLabel;
      panel.appendChild(cta);

      // Plus de redirection automatique : le client part vers la connexion quand il
      // clique, pas pendant qu'il lit (decision Joris, 29/09/2026).
      card.appendChild(panel);
    }

    function isEmailInput(node) {
      if (!node || node.tagName !== "INPUT") return false;
      return (
        node.id === "email" ||
        node.type === "email" ||
        (node.getAttribute && node.getAttribute("inputmode") === "email")
      );
    }

    function captureEmail(scope) {
      var input =
        scope.querySelector("#email") ||
        scope.querySelector('input[inputmode="email"]') ||
        scope.querySelector('input[type="email"]');
      if (input && input.value) {
        capturedEmail = input.value.trim();
      }
    }

    function attach(shadowRoot, formRoot) {
      // Capture continue de l'e-mail. Les evenements sont ecoutes AU NIVEAU
      // du shadow root : e.target y est l'input reel (pas retargete).
      function onValue(e) {
        if (isEmailInput(e.target) && e.target.value) {
          capturedEmail = e.target.value.trim();
        }
      }
      shadowRoot.addEventListener("input", onValue, true);
      shadowRoot.addEventListener("change", onValue, true);

      function isSuccess() {
        var step = formRoot.getAttribute("data-current-step");
        if (step && step !== "form") return true; // etape de confirmation
        if (!shadowRoot.querySelector("form")) return true; // form disparu
        return false;
      }

      var observer = new MutationObserver(function () {
        if (redirecting) {
          observer.disconnect();
          return;
        }
        // Dernier filet pour capter l'e-mail avant disparition du champ.
        captureEmail(shadowRoot);
        if (isSuccess()) {
          observer.disconnect();
          showPanelAndRedirect();
        }
      });
      observer.observe(shadowRoot, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["data-current-step"],
      });
    }

    // <shopify-forms-embed> est present des le HTML serveur, mais son shadow
    // root (et [data-form-root]) sont hydrates en JS par l'app. On attend.
    var waited = 0;
    var poll = window.setInterval(function () {
      var embed = container.querySelector("shopify-forms-embed");
      var shadowRoot = embed && embed.shadowRoot;
      var formRoot = shadowRoot && shadowRoot.querySelector("[data-form-root]");
      if (formRoot) {
        window.clearInterval(poll);
        attach(shadowRoot, formRoot);
      } else if ((waited += POLL_INTERVAL) >= POLL_TIMEOUT) {
        window.clearInterval(poll);
      }
    }, POLL_INTERVAL);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
